import React from 'react';
// import Plans from './plans/Plans';
import Footer from '../../layouts/Footer';
import UnauthenticatedNav from '../../layouts/UnauthenticatedNav';
import Account from '../accounts/mac/Account';

const SubscribeWithMac = () => {
  return (
    <div className="container-fluid p-0" id="">
      <UnauthenticatedNav />
      <hr className="mt-0 mb-3 d-flex d-md-none" />
      <div className="container" id="page-container">
        <Account />
        {/* <Plans /> */}
      </div>
      <Footer />
    </div>
  );
};

export default SubscribeWithMac;
